import { render, staticRenderFns } from "./AccountTypeView.vue?vue&type=template&id=1ddbbca6&"
import script from "./AccountTypeView.vue?vue&type=script&lang=js&"
export * from "./AccountTypeView.vue?vue&type=script&lang=js&"
import style0 from "./AccountTypeView.vue?vue&type=style&index=0&id=1ddbbca6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports